import styled from 'styled-components';

import DecorativeImage from 'components/DecorativeImage';

import amexIconUrl from './assets/amex-icon.svg';
import dinersIconUrl from './assets/diners-icon.svg';
import discoverIconUrl from './assets/discover-icon.svg';
import jcbIconUrl from './assets/jcb-icon.svg';
import maestroIconUrl from './assets/maestro-icon.svg';
import mastercardIconUrl from './assets/mastercard-icon.svg';
import unionPayIconUrl from './assets/unionPay-icon.svg';
import unknownIconUrl from './assets/unknown-icon.svg';
import visaIconUrl from './assets/visa-icon.svg';

export const BRAND_ICONS_MAP = {
  amex: amexIconUrl,
  diners: dinersIconUrl,
  discover: discoverIconUrl,
  jcb: jcbIconUrl,
  maestro: maestroIconUrl,
  mastercard: mastercardIconUrl,
  unionPay: unionPayIconUrl,
  unknown: unknownIconUrl,
  visa: visaIconUrl,
};

interface BrandIconProps {
  brand: keyof typeof BRAND_ICONS_MAP;
}

export const BrandIcon = styled(DecorativeImage).attrs(
  ({ brand }: BrandIconProps) => ({
    heightPx: 20,
    src: BRAND_ICONS_MAP[brand],
    widthPx: 33,
  }),
)<BrandIconProps>`
  position: absolute;
  right: ${({ theme }) => theme.spacings.abs8}px;
  bottom: 14px;
`;
